import React from "react";

const EditarImagem = ({
  img,
  handleImageUpload,
  setImagem,
  imagemInicial,
  carteiraId,
  save,
  isRecepcionada,
}) => {
  const isInputDisabled = !isRecepcionada && save !== carteiraId;
  
  return (
    <div className="w-34 max-h-48 rounded-2xl mt-2">
      <input
        className={`z-10 relative bottom-2 opacity-0 w-full h-48 ${
          isInputDisabled ? 'pointer-events-none' : ''
        }`}
        type="file"
        name="imagem"
        onChange={(e) => {
          const file = e.target.files[0];
          setImagem(carteiraId, file); // Atualiza o estado local
          handleImageUpload(carteiraId, file); // Faz o upload da imagem imediatamente
        }}
        disabled={isInputDisabled}
      />
      {img ? (
        <img
          className="z-0 relative bottom-2 -mt-24 min-w-full min-h-full rounded-xl"
          src={URL.createObjectURL(img)}
          alt="imagem"
          style={{ pointerEvents: isInputDisabled ? 'auto' : 'none' }}
        />
      ) : (
        <img 
          className="z-0 relative bottom-2 -mt-48 w-full h-[190px] rounded-xl"
          src={imagemInicial} 
          alt="imagem"
          style={{ pointerEvents: isInputDisabled ? 'auto' : 'none' }}
        />
      )}
    </div>
  );
};

export default EditarImagem;
